module.exports = __webpack_public_path__ + "sg-small.6071e142.png";